import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "about" */ '../views/home.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/about.vue')
  }
,
{
  path: '/contact',
  name: 'Contact',
  component: () => import(/* webpackChunkName: "contact" */ '../views/contact.vue')
},
// {
//   path: '/service',
//   name: 'Service',
//   component: () => import(/* webpackChunkName: "Service" */ '../views/service.vue')
// },
{
  path: '/electric',
  name: 'Electric',
  component: () => import(/* webpackChunkName: "Electric" */ '../views/electric.vue')
},
{
  path: '/iehcontrol',
  name: 'IEHcontrol',
  component: () => import(/* webpackChunkName: "IEHcontrol" */ '../views/iehcontrol.vue')
},
{
  path: '/gallery',
  name: 'Gallery',
  component: () => import(/* webpackChunkName: Gallery" */ '../views/gallery.vue')
}
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
